import { createValidationSchema, stringField, uuidField, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const getTenantPaymentCredentials = {
    name: "getTenantPaymentCredentials",
    description: "Returns the payment credentials configuration status for a tenant.",
    type: "query",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        tenantId: uuidField({
            required: true,
            message: "Debe ingresar un ID de tenant válido",
        }),
        provider: stringField({
            required: false,
            message: "El provider es opcional",
        }),
    }),
    useCase: async ({ db, tenantConnectionResolver, }, { tenantId, provider = "mercadopago", }) => {
        const tenant = await db.findOne(TenantEntity, {
            where: { id: tenantId },
        });
        if (!tenant)
            return new TenantNotFoundError();
        const connection = await tenantConnectionResolver.open(tenant.dbName);
        try {
            const rows = await connection.manager.query(`SELECT publicKey, transferDetails
                 FROM payment_credentials
                 WHERE provider = ? AND isActive = true
                 LIMIT 1`, [provider]);
            const first = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
            if (!first) {
                return {
                    provider,
                    isConfigured: false,
                    publicKey: null,
                    transferDetails: null,
                };
            }
            return {
                provider,
                isConfigured: true,
                publicKey: first.publicKey ?? null,
                transferDetails: first.transferDetails
                    ? JSON.parse(first.transferDetails)
                    : null,
            };
        }
        finally {
            await connection.release();
        }
    },
};
